(function () {
  function init(root) {
    var pills = root.querySelectorAll('[data-filter]');
    var cards = root.querySelectorAll('[data-grid] .pc');
    var sort = root.querySelector('[data-sort]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var filter = pill.getAttribute('data-filter');
        pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
        cards.forEach(function (card) {
          var show = filter === 'all' || card.getAttribute('data-type') === filter;
          if (show) card.removeAttribute('hidden');
          else card.setAttribute('hidden', '');
        });
      });
    });

    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    }
  }

  document.querySelectorAll('.colgrid').forEach(init);
})();
